import React, { useContext } from "react";
import "./index.scss";
import BarInfo from "../../mediaContent/barInfo";
import { StepContext } from "../StepContext";
import { useTranslation } from "../../i18n";

const StepFooter = ({
  stepInfo
}) => {
  const {
    _t,
    language
  } = useTranslation();
  const {
    isPatient,
    openVideoViewer,
    toggleRightBarInfo
  } = useContext(StepContext);

  function showAbout(key) {
    if (isPatient) {
      const selectedItem = BarInfo(language).find(el => el.type === key);
      openVideoViewer(true, selectedItem.preview.video, selectedItem.title);
    } else {
      toggleRightBarInfo(true, key);
    }
  }

  if (!stepInfo.footerText) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "stepLayout-footer"
  }, stepInfo.hasOwnProperty("footerIcon") && /*#__PURE__*/React.createElement("img", {
    src: stepInfo.footerIcon,
    className: "stepLayout-footer-icon",
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: "stepLayout-footer-text",
    dangerouslySetInnerHTML: {
      __html: stepInfo.footerText
    }
  }), stepInfo.hasOwnProperty("rightBarAboutKey") && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => showAbout(stepInfo.rightBarAboutKey),
    className: "btnPrimary footerAboutBtn"
  }, _t("Подробней")));
};

export default StepFooter;